import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=bf3a890c&scoped=true"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"
import style0 from "./Main.vue?vue&type=style&index=0&id=bf3a890c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3a890c",
  null
  
)

export default component.exports